export default {
  translation: {
    navigation: {
      features: "Features",
      tutorial: "Tutorial",
      documentation: "Documentation",
      contact: "Contact"
    },
    homepage: {
      hero: {
        title: "Your Meal Management Companion",
        subtitle: "Stay in control of your diabetes anywhere, anytime",
        downloadApp: "Download on",
        availableOn: "Available on"
      },
      features: {
        title: "Features",
        cards: {
          glucose: {
            title: "Glucose Tracking",
            description: "Track and monitor your blood sugar levels easily"
          },
          meals: {
            title: "Meal Planning",
            description: "Create meal plans tailored to your diabetic needs"
          },
          reminders: {
            title: "Medication Reminders",
            description: "Never miss a dose with our customizable reminders"
          }
        },
        seeMore: "See All Features"
      }
    },
    features: {
      title: "Features",
      cards: {
        glucose: {
          title: "Glucose Tracking",
          description: "Track and monitor your blood sugar levels easily"
        },
        meals: {
          title: "Meal Planning",
          description: "Create meal plans tailored to your diabetic needs"
        },
        medication: {
          title: "Medication Reminders",
          description: "Never miss a dose with our customizable reminders"
        },
        sync: {
          title: "Multi-device Sync",
          description: "Access your data from any device"
        },
        reports: {
          title: "Detailed Reports",
          description: "Generate comprehensive health reports"
        },
        alerts: {
          title: "Custom Alerts",
          description: "Get notified when your levels need attention"
        }
      }
    },
    contact: {
      title: "Contact Us",
      subtitle: "We're here to help",
      form: {
        name: "Your Name",
        email: "Email Address",
        subject: "Subject",
        message: "Message",
        submit: "Send Message"
      },
      success: "Message sent! We'll get back to you soon."
    },
    tutorial: {
      title: "How It Works",
      subtitle: "Watch our quick tutorial to learn how to use MANAGEGLI effectively",
      video: {
        thumbnail: "MANAGEGLI Video Tutorial"
      },
      steps: {
        title: "Step by Step Guide",
        step1: {
          title: "Create Your Account",
          description: "Sign up with your email and create a personalized profile"
        },
        step2: {
          title: "Set Your Parameters",
          description: "Enter your glucose targets and meal preferences"
        },
        step3: {
          title: "Start Recording",
          description: "Add your first measurements and meals"
        },
        step4: {
          title: "Analyze Your Data",
          description: "Review your trends and adjust your habits"
        }
      }
    },
    documentation: {
      title: "Documentation",
      sections: "Sections",
      sidebar: {
        getting_started: "Getting Started",
        features: "Features",
        meal_planning: "Meal Planning",
        glucose_tracking: "Glucose Tracking",
        reports: "Reports",
        faq: "FAQ"
      },
      getting_started: {
        welcome: "Welcome to MANAGEGLI, your diabetic meal management companion. This guide will help you set up and use the application effectively.",
        installation: "Installation",
        installation_text: "Download the app from the App Store or Google Play and follow the installation instructions.",
        initial_setup: "Initial Setup",
        initial_setup_text: "After signing up, you'll be guided through setting up your profile and preferences."
      },
      features: {
        overview: "MANAGEGLI offers a comprehensive set of tools to help you manage your diabetes daily.",
        real_time_glucose_tracking: "Real-time glucose monitoring",
        meal_planning: "Meal planning",
        food_database: "Extensive food database",
        medication_reminders: "Medication reminders",
        detailed_reports: "Detailed reports",
        device_sync: "Multi-device synchronization",
        secure_sharing: "Secure sharing with healthcare providers"
      },
      meal_planning: {
        overview: "Easily create balanced meal plans with our intuitive planning tool.",
        main_features: "Main Features",
        personalized_suggestions: "Personalized meal suggestions",
        automatic_carb_calculation: "Automatic carb counting",
        diet_alternatives: "Alternatives for different diets"
      },
      glucose_tracking: {
        overview: "Monitor your glucose levels effectively with our advanced tracking tools.",
        tracking_features: "Tracking Features",
        easy_recording: "Easy measurement recording",
        real_time_graphs: "Real-time graphs",
        custom_alerts: "Customizable alerts"
      },
      reports: {
        overview: "Generate detailed reports to track your progress."
      },
      faq: {
        questions: "Frequently Asked Questions",
        sync_data: "How do I sync my data?",
        sync_data_text: "Sign in to your account on all your devices for automatic synchronization.",
        offline_usage: "Does the app work offline?",
        offline_usage_text: "Yes, you can use basic features without an internet connection."
      }
    },
    footer: {
      tagline: "Take control of your diet and blood sugar! With MANAGEGLI, access specially designed meals for diabetics and monitor your blood sugar with ease. Make informed choices, visualize your trends, and maintain optimal health. Eat better, live better!",
      social: {
        title: "Social",
        follow: "Follow us on"
      },
      navigation: "Navigation",
      copyright: "© 2025 MANAGEGLI. All rights reserved.",
      company: "By MERCY INNOVATION LAB"
    },
    accessibility: {
      changeLanguage: "Switch to French",
      toggleTheme: "Toggle dark mode",
      mainMenu: "Main menu"
    }
  }
}